import { selectCurrentEntityIds } from 'ducks/entities/selectors'

// eslint-disable-next-line no-underscore-dangle
export const _selectSortedIds = state =>
  selectCurrentEntityIds(state, 'channel')
